export const assessmentTemplate = [
  {
    _id: "hyperOnboard",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2023-07-21T00:00:00Z",
      modifiedBy: "melissaadmin9999",
      modifiedDate: "2023-07-21T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "hyperOnboard",
      omniTypeVersion: 1,
      title: "Hyberbaric Wellness Onboarding",
      purpose: "Onboard new patients",
      description:
        "The information you provide will help us understand your personal health needs. We use this to match you to available treatments.",
      duration: "Around 2 minutes",
      directions:
        "Follow the onscreen instructions after you begin.</br></br>You can take this assessment again any time you experince a change in your health.",
      attribution: "",
      validated: "true",
      startDate: null,
      selfAssessment: true,
      completeDate: null,
      questions: [
        {
          omniID: "hbo1",
          shortTitle: "subjectDateOfBirth",
          numberText: "1",
          text: "What is {subject name's/your} date of birth?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "date",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Date of Birth",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hbo2",
          shortTitle: "subjectNeurologistReason",
          numberText: "2",
          text: "{has/have} {subject name/you} been diagnosed with any of the following before having Covid?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "alz",
              text: "Alzheimer's disease (ALZ)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "dem",
              text: "Dementia",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "cf",
              text: "Chronic Fatigue",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "fib",
              text: "Fibromyalgia",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hb3",
          shortTitle: "subjectSymptoms",
          numberText: "3",
          text: "Which of the following symptoms have you had since being diagnosed with Covid?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "fatigue",
              text: "Fatigue",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "shortnessofBreath",
              text: "Shortness of breath",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "weakness",
              text: "Weakness",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "brainfog",
              text: "Brain fog",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "headaches",
              text: "Headaches",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "tremor",
              text: "Tremor",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "rapidHeartBeat",
              text: "Rapid or Pounding Heartbeat",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "dizziness",
              text: "Dizziness upon standing",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hb4",
          shortTitle: "subjectWeight",
          numberText: "4",
          text: "What is {subject name's/your} weight?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "weight",
          answerOptions: [
            {
              value: "",
              text: "Weight",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hb5",
          shortTitle: "subjectHeight",
          numberText: "5",
          text: "What is {subject name's/your} height?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "height",
          answerOptions: [
            {
              value: "",
              text: "Height",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "hyperOnboard",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 0,
        formula: null,
        questions: [],
      },
    ],
  },
];
